'use client';

import { Box } from '@mui/material';
import { GridCellParams, GridCheckIcon, GridCloseIcon } from '@mui/x-data-grid';
import React from 'react';

export const ConversionRightsCell = ({ row, value }: GridCellParams) => {
	const { rightToConvert } = row;

	const IconToShow = value ? GridCheckIcon : GridCloseIcon;

	if (!rightToConvert) return <GridCloseIcon fontSize='small' />;

	return (
		<Box
			sx={{
				width: '100%',
				height: '100%',
				display: 'flex',
				alignItems: 'center',
			}}
		>
			<IconToShow fontSize='small' />
		</Box>
	);
};
